import { render, staticRenderFns } from "./MotorwayComponent.vue?vue&type=template&id=08296c29"
import script from "./MotorwayComponent.vue?vue&type=script&lang=ts"
export * from "./MotorwayComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports